<template>
  <v-container text-xs-center fluid>
    <v-layout row wrap style="margin: 0px">
      <v-flex xs12 style="padding: 5px">
        <v-card text-xs-center elevation="0">
          <v-layout row wrap style="padding: 4%;">
            <v-flex xs12 md12 sm12 d-flex justify-center>
              <v-avatar size="90">
                <img :src="computeLogo" alt="GoDial" />
              </v-avatar>
            </v-flex>

            <v-flex xs12 md12 sm12 d-flex justify-center style="padding: 2%;">
              GoDial Enterprise
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <div style="padding: 45px 15px; text-align: center;">
            <h1>You need to enable this to be able to receive outward calls</h1>
          </div>

          <div style="padding: 15px 15px; text-align: center;">
            <v-card>
              <v-row>
                <v-col> </v-col>
                <v-col style="padding:0">
                  <div
                    style="padding: 45px 15px; text-align: center;float:left"
                  >
                    <h2>Enable Zapier</h2>
                  </div>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="zapier.enabled"
                    color="primary"
                    style="padding-top:5%"
                    :label="zapier.enabled === true ? 'Yes' : 'No'"
                    on-click
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row style="margin-left:30%,margin-right:30%;width:90%">
                <v-col cols="3"></v-col>
                <v-col cols="8">
                  <v-flex
                    xs12
                    sm10
                    offset-sm1
                    md10
                    offset-md1
                    style="margin-bottom: 10px;"
                  >
                    <v-btn color="primary" block @click="setZapierCompany"
                      >Save</v-btn
                    >
                  </v-flex>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container></template
>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      zapier: { enabled: false },
    };
  },
  created() {
    this.initialState();
  },
  computed: {
    ...mapState(["ENDPOINT", "companyDetails"]),
    companyDetails() {
      return this.$store.getters.companyDetails;
    },

    computeLogo() {
      if ("picture" in this.companyDetails) {
        return `${this.$store.state.ENDPOINT}/storages/get/${this.companyDetails.picture.name}?access_token=${this.$store.getters.user.token}`;
      } else {
        return require("../assets/logo.png");
      }
    },
  },
  methods: {
    initialState() {
      this.zapier.enabled = this.companyDetails.zapier.enabled;
    },
    async setZapierCompany() {
      try {
        const self = this;
        // Add Zapier Details In Company Data
        var company = await self.$http.patch(
          `${self.ENDPOINT}/companies/${self.$store.state.companyDetails.id}`,
          {
            zapier: {
              enabled: self.zapier.enabled,
            },
          }
        );

        // Success Message
        if (company.status == 200) {
          // Set Company Object for Store dispatch
          var companyObj = { companyId: company.body.id };
          self.$store.dispatch("getCompanyDetails", companyObj);
          self.loader = false;

          return self.$swal({
            type: "success",
            text: "Zapier State Added to Godial Successfully",
          });
        } else {
          return self.$swal({
            type: "warning",
            text: "Something Went Wrong",
          });
        }
      } catch (err) {
        console.log(err);
        self.loader = false;
        return self.$swal({
          type: "warning",
          text: err,
        });
      }
    },
  },
};
</script>
